import React from "react";
import GovGr500Page from ".";
import GovGrDrawerMenu from "../GovGrDrawerMenu";

const GovGr500PageWrapper = () => {
  return (
    <GovGrDrawerMenu apptitle="E-θυρίδα Ναυτικού" hiddenmenu={true}>
      <GovGr500Page />
    </GovGrDrawerMenu>
  );
};

export default GovGr500PageWrapper;
